import { gql } from 'graphql.macro';

export const switchDataSetTemplate = gql`
    mutation switchDataSet($dataSet: DataSet!) {
        switchDataSet(dataSet: $dataSet) {
            state
            dataSet
            step
            copiedDocuments
            totalDocuments
            copiedCollections
            totalCollections
            currentCollection
            startedAt
            finishedAt
            startedBy
            error
        }
    }
`;
